
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M15 17a1 1 0 011 1v3a1 1 0 01-1 1H9a1 1 0 01-1-1v-3a1 1 0 011-1h6zm-8.75-5.75a.75.75 0 110 1.5H4.579a1 1 0 00-1 1v4a1 1 0 001 1H6.25a.75.75 0 110 1.5H4a2 2 0 01-2-2v-5a2 2 0 012-2h2.25zM15 9.5a1 1 0 011 1v3a1 1 0 01-1 1H9a1 1 0 01-1-1v-3a1 1 0 011-1h6zm5-5.75a2 2 0 012 2v5a2 2 0 01-2 2h-2.25a.75.75 0 110-1.5h1.671a1 1 0 001-1v-4a1 1 0 00-1-1H17.75a.75.75 0 110-1.5zM15 2a1 1 0 011 1v3a1 1 0 01-1 1H9a1 1 0 01-1-1V3a1 1 0 011-1h6z"}})])
          )
        }
      }
    